export default ['cash', 'mortgage', 'military_mortgage', 'housing_certificate'];
